<template>
  <div>
    <!-- begin:: PC端搜索框 -->
    <div v-if="this.$objBaseInfo.channelId == 'WEB'">
      <el-row id="cwt_hotel_booking_search">
        <div class="result_search_panel_bg"></div>
        <div class="result_search_panel">
          <div class="opt_search">
            <destination
              :returnParentValue="setDestinationVal"
              :parentCityCode="cityCode"
              @returnCityInfo="setDestination"
              :isOnlyCity="false"
            ></destination>
          </div>
          <div class="opt_search date_width">
            <date-picker
              :setValue="setValue"
              @returnCheckDate="setCheckDate"
            ></date-picker>
          </div>
          <div class="opt_search room_width">
            <Guests
              :roomCount="roomNum"
              :guestCount="guestNum"
              @setRoomNum="setRoomNum"
              @setAdultNum="setGuestNum"
            ></Guests>
          </div>
          <div class="opt_search">
            <KeywordSearch
              @returnKeyWord="returnKeyWord"
              :keywordInput="inputKeyword"
              :isVisible="isVisible"
              :parentCityCode="cityCode"
            ></KeywordSearch>
            <!-- <el-input :placeholder="$t('RESULT.KEYWORDS')" v-model="inputKeyword" @input="keyInput">
              <svg-icon slot="prefix" icon-class="search" class-name="hotel_input__icon el-icon-search"></svg-icon>
            </el-input> -->
          </div>
          <div class="btn_search">
            <button class="s_btn r_search_btn" @click="searchResult()">
              {{ $t("HOME.BUTTONSEARCH") }}
            </button>
          </div>
        </div>
      </el-row>
    </div>
    <!-- end:: PC端搜索框 -->
    <!-- begin:: 移动端搜索框 -->
    <div v-else class="inout_search_list">
      <div class="inout_list list_r_border search_city">
        <destination
          :isDisplayText="true"
          :returnParentValue="setDestinationVal"
          :parentCityCode="cityCode"
          @returnCityInfo="setDestination"
          :isOnlyCity="false"
        ></destination>
      </div>
      <div class="inout_list list_r_border search_calendar">
        <date-picker
          :isDisplayText="true"
          :setValue="setValue"
          @returnCheckDate="setCheckDate"
        ></date-picker>
      </div>
      <div class="inout_list list_r_border search_numpeople">
        <Guests
          :isDisplayText="true"
          :roomCount="roomNum"
          :guestCount="guestNum"
          @setRoomNum="setRoomNum"
          @setAdultNum="setGuestNum"
        ></Guests>
      </div>
      <div class="inout_list search_keyword">
        <div class="search">
          <i aria-hidden="true" class="el-icon-search"></i>
          <KeywordSearch
            @returnKeyWord="returnKeyWord"
            :keywordInput="inputKeyword"
            :isVisible="isVisible"
            :isMobileResultKeyword="true"
            :parentCityCode="cityCode"
          ></KeywordSearch>
          <!-- <input type="text" class="s_input" readonly="readonly" :value="inputKeyword" :placeholder="$t('SEARCH.KEYWORDS')" @click="searchShow =true" /> -->
        </div>
        <div
          class="currency_change"
          @click="clickCurrency"
          v-if="
            searchType != 'mobileMap' &&
            ($objBaseInfo.destinationType == 'I' || $objBaseInfo.isGATCity)
          "
        >
          <svg-icon
            icon-class="currency"
            class-name=""
          ></svg-icon>
        </div>
        <div class="currency_change" @click="gomap" v-if="isResultView">
          <svg-icon icon-class="ic_map"></svg-icon>
        </div>
        <van-popup
          v-model:show="currencyShow"
          position="top"
          :style="{ height: '35%' }"
        >
          <h2 style="text-align: center; padding: 1rem">
            {{ $t("SEARCH.CURRENCYTITLE") }}
          </h2>
          <van-radio-group v-model="areaRadio">
            <van-cell-group>
              <van-cell
                class="currency_cell"
                v-for="item in currencyList"
                :key="'currency' + item"
                :title="item"
                clickable
                @click="currencyChange(item)"
              >
                <template #right-icon>
                  <van-radio :name="item" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
          <van-button
            type="danger"
            style="margin-top: 1rem"
            block
            round
            @click="currencyChange"
          >
            {{ $t("MESSAGE.RESETBTN") }}
          </van-button>
        </van-popup>
      </div>
      <van-popup
        v-model:show="searchShow"
        position="bottom"
        :style="{ height: '80%' }"
      >
        <form>
          <van-search
            class="m_search"
            v-model="inputKeyword"
            show-action
            @input="keyInput"
            :placeholder="$t('SEARCH.KEYWORDS')"
            @search="searchResult('mobile')"
          >
            <template #action>
              <div @click="searchResult('mobile')">
                {{ $t("RESULT.SEARCH") }}
              </div>
            </template>
          </van-search>
        </form>
      </van-popup>
    </div>
    <!-- end:: 移动端搜索框 -->
    <ConfirmBoxs
      :centerDialogVisible="confirmFlag"
      :confirmMsg="confirmMsg"
      :icon="confirmIcon"
      @setConfirmFlag="setConfirmFlag"
    ></ConfirmBoxs>
  </div>
</template>

<script>
import DatePicker from "./DatePicker.vue";
import Destination from "./Destination.vue";
import Guests from "../components/Guests.vue";
import KeywordSearch from "../components/KeywordSearch.vue";
import { locationList,getHotelTravelRule } from "@/api/shoppingData";
import { formatDateTime } from "@/utils/utils.js";
import ConfirmBoxs from "./confirmBoxs.vue";
import {
  validateTrip,
  getCurrencyList,
  getCityInfoByCode,
  isCityGAT,
} from "@/utils/utils";

export default {
  name: "ResultSearch",
  props: {
    searchInfo: {
      type: Object,
    },
    locationCode: {
      type: String,
    },
    pageCount: {
      type: Number,
    },
    searchType: {
      type: String,
    },
    keywordInput: {
      type: Object,
    },
    isResultView: {
      type: Boolean,
    },
    PositionCityCode: {
      type: String,
    },
  },
  components: {
    DatePicker,
    Destination,
    Guests,
    ConfirmBoxs,
    KeywordSearch,
  },
  data() {
    return {
      confirmIcon: "",
      confirmFlag: false,
      confirmMsg: "",
      loading: false,
      value1: "",
      inputKeyword: "",
      setDestinationVal: "",
      cityCode: "",
      setValue: [],
      cityInfo: "",
      searchParam: {},
      roomNum: "",
      guestNum: "",
      searchShow: false,
      isPost: false, // 是否允许请求
      currencyList: [],
      currencyShow: false,
      areaRadio: "",
      keywordType: "input", //关键字类型： input 输入 ；auto 带出
      isVisible: true,
    };
  },
  mounted() {
    this.Destination();
    //币种
    this.currencyList = getCurrencyList();
  },
  watch: {
    keywordInput(newVal) {
      if (newVal) {
        this.inputKeyword = newVal.keyword;
        this.keywordType = newVal.keywordType;
      }
    },
    "$i18n.locale"() {
      if (this.keywordType == "auto") {
        this.inputKeyword =
          this.searchParam.city.cityInfo.locationName[
            this.$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")
          ];
      }
    },
    PositionCityCode(newVal) {
      if (newVal) {
        this.cityCode = newVal;
        getCityInfoByCode(this.cityCode).then((city) => {
          if (city) {
            city.locationType = 0; 
            this.setDestination({ 
              cityName: city.cityNameLists[this.$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")],
              cityCode: city.cityCode,
              cityInfo: city,
            });
            this.$emit('clearPositionCityCode');
          }
        });
      }
    },
  },
  computed: {},
  methods: {
    keyInput() {
      this.keywordType = "input";
    },
    // 关键词搜索返回信息
    returnKeyWord(keyValue) {
      if (keyValue && keyValue.keyword) {
        this.keywordType = keyValue.keywordType;
        if (this.keywordType == "input") {
          this.inputKeyword = keyValue.keyword;
        } else {
          this.cityCode = keyValue.keyword.cityCode;
          this.setDestination({
            cityCode: keyValue.keyword.cityCode,
            cityName:
              keyValue.keyword.cityNameLists[
                this.$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")
              ],
            cityInfo: keyValue.keyword,
          });
        }
      } else {
        this.keywordType = "input";
        this.inputKeyword = "";
      }
      if (this.$objBaseInfo.channelId == "MOBILE" && keyValue.isSearech) {
        this.searchResult();
      }
    },
    //币种弹出层 mobile
    clickCurrency() {
      this.currencyShow = true;
    },
    //币种切换
    currencyChange(item) {
      this.areaRadio = item;
      this.currencyShow = false;
      let val = this.currencyList.indexOf(item);
      this.$emit("changeCurrency", val > -1 ? val.toString() : "");
    },
    async getLocationData() {
      // this.loading = true;
      //if (this.searchType != "mobileMap") {
      try {
        this.chooseCode = this.cityInfo ? this.cityInfo : this.cityCode;
        const res = await locationList({
          params: { cityCode: this.chooseCode, locationType: 1, isEnable: 1 },
        });
        if (res.code == 200) {
          this.locationName = res.data.list;
        } else {
          this.locationName = [];
        }
        this.locationName.loading = false;
        this.$emit("locationInfo", this.locationName);
      } catch (e) {
        this.locationName = [];
        this.locationName.loading = false;
        this.$emit("locationInfo", this.locationName);
      }
      //}
    },
    //子组件确认框
    setConfirmFlag(value) {
      this.confirmFlag = value;
    },
    Destination() {
      this.cwtCityCode =
        this.cityInfo =
        this.cityCode =
          this.searchInfo.city.cityCode;
      this.searchParam.city = this.searchInfo.city;
      this.checkInDate = formatDateTime(this.searchInfo.checkInAt,"YYYY-MM-DD");
      // 离店
      this.checkOutDate = formatDateTime(this.searchInfo.checkOutAt,"YYYY-MM-DD");
      this.setValue = [this.checkInDate, this.checkOutDate];
      this.inputKeyword = this.searchInfo.keyword;
      this.keywordType = this.searchInfo.keywordType
        ? this.searchInfo.keywordType
        : "input";
      this.searchParam.roomNum = this.roomNum = this.searchInfo.roomCount;
      this.searchParam.guestNum = this.guestNum = this.searchInfo.guestCount;
      if (this.searchParam.city.cityInfo) {
          this.searchResult();
      } else {
        getCityInfoByCode(this.cwtCityCode).then((city) => {
          if (city) {
            this.searchParam.city.cityInfo = city;
            this.searchResult();
          }
        });
      }
    },
    // 子组件赋值房间数 guest组件
    setRoomNum(value) {
      this.searchParam.roomNum = value;
    },
    // 子组件赋值人数 guest组件
    setGuestNum(value) {
      this.searchParam.guestNum = value;
    },
    // 子组件赋值目的城市 destination组件
    setDestination(value) {
      this.searchParam.city = value;
      this.cityInfo = value.cityCode;
      this.cwtCityCode = value.cityCode;
      if (value.cityInfo) {
        this.$objBaseInfo.countryCode = value.cityInfo.countryCode;
        this.$objBaseInfo.isGATCity = isCityGAT(value.cityInfo.provinceCode);
        this.$objBaseInfo.provinceCode = value.cityInfo.provinceCode;
        this.cityCode = value.cityInfo.cityCode;
        this.$forceUpdate();
        if (value.cityInfo.locationType != 0) {
          this.keywordType = "auto";
          this.inputKeyword =
            value.cityInfo.locationName[
              this.$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")
            ];
        } else {
          this.keywordType = "input";
          this.inputKeyword = "";
        }
      } else {
        this.keywordType = "input";
        this.inputKeyword = "";
      }
      if (this.$objBaseInfo.channelId == "MOBILE" && this.cwtCityCode) {
        //移动端
        this.searchResult();
      }
    },
    // 子组件赋值入住 离店时间 datepicker组件
    setCheckDate(value) {
      if (value && value.length > 0) {
        this.setValue = value;
        // 入住
        this.checkInDate = formatDateTime(value[0], "YYYY-MM-DD");
        // 离店
        this.checkOutDate = formatDateTime(value[1], "YYYY-MM-DD");
        // this.getHotelData();

        //移动端
        if (this.$objBaseInfo.channelId == "MOBILE") {
          this.searchResult();
        }
      } else {
        this.$emit("hotelInfo", []);
        // this.$emit("locationInfo", []);
      }
    },
    searchResult(param) {
      this.isVisible = !this.isVisible; //关闭keywords搜索的弹框
      this.areaRadio = "";
      if (param === "mobile") {
        this.searchShow = false;
      }
      this.searchParam.cityInfo = this.cityInfo;
      this.searchParam.checkInDate = this.checkInDate;
      this.searchParam.checkOutDate = this.checkOutDate;
      //str.trim()
      this.searchParam.keyword =
        this.keywordType == "input" ? this.inputKeyword?.trim() : "";
      if (!this.cityInfo) {
        this.confirmIcon = "exclamation";
        this.confirmMsg = this.$t("SEARCH.CONFIRMDES");
        this.confirmFlag = true;
      } else if (this.setValue == undefined || this.setValue.length <= 0) {
        this.confirmIcon = "exclamation";
        this.confirmMsg = this.$t("SEARCH.CONFIRMCHECK");
        this.confirmFlag = true;
      } else {
        //行程单验证
        let msg = validateTrip(
          this,
          this.cwtCityCode,
          this.checkInDate,
          this.checkOutDate
        );
        if (!this.judgeCTCiyt()) {
          this.confirmIcon = "exclamation";
          this.confirmMsg = this.$t("HOME.JUDGECTCITYTITLE");
          this.confirmFlag = true;
          return false;
        }
        if (msg != "") {
          this.confirmFlag = true;
          this.confirmMsg = msg;
          if (this.$objBaseInfo.channelId == "WEB") {
            this.setValue = [];
            this.$emit("locationInfo", []);
          }
          this.$emit("hotelInfo", []);
        } else {
          //记录搜索条件
          let query = this.$store.state.pathQuery;
          if (query.searchParam) {
            let searchParam = JSON.parse(query.searchParam);
            searchParam.checkInAt = this.checkInDate;
            searchParam.checkOutAt = this.checkOutDate;
            // searchParam.city.cityCode = this.cityInfo;
            this.searchParam.isCityChange = ! (searchParam.city.cityCode == this.searchParam.city.cityCode);
            searchParam.city = this.searchParam.city;
            searchParam.keyword =
              this.keywordType == "input" ? this.inputKeyword?.trim() : "";
            // searchParam.guestCount = guestCount;
            // searchParam.roomCount = roomCount;
            query.searchParam = JSON.stringify(searchParam);
            this.$store.commit("changePathQuery", query);
          }
          this.searchParam.keywordType = this.keywordType;
          this.$emit("fromSearch", this.searchParam);
          this.getLocationData();
          if(this.$objBaseInfo.showTravelTitle){
            this.getPersonalizationTravelRule();
          }
        }
      }
    },
    judgeCTCiyt() {
      let ctCity = this.$objBaseInfo.ctCity;
      if (ctCity == undefined || ctCity == null || ctCity == "") {
        return true;
      }
      //判断所选城市是否在国家中屏蔽
      if (ctCity.hasOwnProperty("countryCode")) {
        let countryCode = ctCity.countryCode;
        //排除中国，下边额外判断
        if (
          countryCode.indexOf(this.searchParam.city.cityInfo.countryCode) >= 0 &&
          this.searchParam.city.cityInfo.countryCode != "100000"
        ) {
          return false;
        }
        //判断所选国家为中国，也屏蔽中国，判断排除是否屏蔽港澳台
        if (
          this.searchParam.city.cityInfo.countryCode?.indexOf("100000") >= 0 &&
          countryCode.indexOf("100000") >= 0 &&
          ctCity.hasOwnProperty("chinaType")
        ) {
          //屏蔽城市包含港澳
          if (ctCity.chinaType.indexOf(this.searchParam.city.cityInfo.provinceCode) >= 0) {
            return false;
          }

          //判断所选是否为台湾城市
          if (
            ctCity.chinaType.indexOf("710000") >= 0 &&
            this.searchParam.city.cityInfo.provinceCode.indexOf("710000") >= 0
          ) {
            return false;
          }

          //判断所选是否为大陆城市  排除台湾，香港，澳门
          if (
            ctCity.chinaType.indexOf("100000") >= 0 &&
            this.searchParam.city.cityInfo.provinceCode.indexOf("710000") < 0 &&
            this.searchParam.city.cityInfo.provinceCode.indexOf("810000") < 0 &&
            this.searchParam.city.cityInfo.provinceCode.indexOf("820000") < 0
          ) {
            return false;
          }
        }
      }
      //判断所选城市是否在城市中屏蔽
      if (ctCity.hasOwnProperty("cityCode")) {
        let cityCode = ctCity.cityCode;
        if (cityCode.indexOf(this.searchParam.city.cityInfo.cityCode) >= 0) {
          return false;
        }
      }
      return true;
    },
    gomap() {
      this.$emit("gomap");
    },
    getPersonalizationTravelRule(){
      var policyParms = {
        params: {
          customerCode: this.$objBaseInfo.customerCode,
          cityCode: this.cityInfo,
          countryCode: this.$objBaseInfo.countryCode,
          bookingContactId: this.$objBaseInfo.loginID
        }
      }
      getHotelTravelRule(policyParms)
      .then((res) => {
        this.$objBaseInfo.displayTravelRules = true;
        if (res.code == 200 && res.data) {
          this.$objBaseInfo.personalizationPolicyInfo = res.data.travelrule;
          this.$objBaseInfo.displayTravelRules = res.data.travelrule.isShowTravelTitle;
        }else{
          this.$objBaseInfo.personalizationPolicyInfo = "";
        }
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
/* 手机、平板屏幕 */
@media screen and (max-width: 960px) {
  .currency_change {
    padding: 0 0.5rem;

    .svg-icon {
      width: 2.8rem;
      height: 2.8rem;
    }
  }

  ::v-deep .v-modal {
    z-index: 0 !important;
  }

  ::v-deep .van-search__action {
    padding-left: 1rem;
    font-size: 1.4rem;
  }
  ::v-deep .el-input__wrapper {
    background-color: #E7E9EA;
  }
  ::v-deep .el-input__inner {
    height: 5rem;
    line-height: 5rem;
  }

  ::v-deep .el-range-editor .el-range-input {
    background-color: #E7E9EA;
  }

  ::v-deep .el-input--prefix .el-input__inner {
    padding-left: 45px;
  }

  .result_search_panel_bg {
    height: 30rem;
    width: 100%;
    position: absolute;
    // background: url('../assets/img/result_hotel_bg.jpg') no-repeat;
    background-size: cover;
    background-color: #FFFFFF;
    // opacity: 0.5;
    // box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  }

  .result_search_panel {
    display: block;
    text-align: center;
    height: 30rem;
    padding: 0;

    .opt_search {
      width: 85%;
      display: inline-block;
      margin: 0.5rem auto;
    }

    .btn_search {
      width: unset;
      display: inline-block;

      button {
        position: relative;
      }
    }
  }

  .r_search_btn {
    width: 12.5rem;
    height: 5rem;
    font-size: 1.8rem;
    display: inline;
  }

  .m_search {
    padding: 1rem 1.1rem;
  }

  .van-search__content {
    padding-left: 1rem;
  }

  .inout_search_list {
    display: flex;
    background-color: $bg-color;
    border-radius: 1.5rem;
    padding: 0 0.4rem;
    height: unset;
    margin: 1rem 0.5rem;
    font-size: 1.3rem;
  }

  .inout_list {
    display: flex;
    align-items: center;
  }

  .currency_cell {
    padding: 1rem 2rem;
  }
}

/* 电脑屏幕 */
@media screen and (min-width: 961px) {

  ::v-deep .el-input__wrapper {
    background-color: #E7E9EA;
  }

  ::v-deep .el-input__inner {
    height: 5rem;
    line-height: 5rem;
  }

  ::v-deep .el-range-editor .el-range-input {
    background-color: #E7E9EA;
  }
  .result_search_panel_bg {
    height: 7.5rem;
    width: 100%;
    position: absolute;
    // background: url('../assets/img/result_hotel_bg.jpg') no-repeat;
    background-size: cover;
    background-color: #FFFFFF;
    // opacity: 0.5;
    // box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  }

  .result_search_panel {
    display: flex;
    height: 5.1rem;
    padding: 1.2rem 6rem;

    .opt_search {
      width: 20%;
      display: inline-block;
      margin-right: 1rem;

      &.date_width {
        width: 29%;
        margin-right: 2rem;
      }

      &.room_width {
        width: 17%;
      }
    }

    .btn_search {
      width: 9.5%;
      display: inline-block;

      button {
        position: relative;
      }
    }
  }

  .r_search_btn {
    width: 12.5rem;
    height: 5rem;
    font-size: 1.8rem;
    display: inline;
  }

  .inout_search_list {
    display: flex;
    background-color: $bg-color;
    border-radius: 1.5rem;
    padding: 0 0.4rem;
    height: 3.6rem;
    margin: 1rem 0.5rem;
    font-size: 1.3rem;
  }
}

.search_city {
  display: flex;
  align-items: center;
  flex: 1;
}

.list_city {
  overflow: hidden;
  text-overflow: ellipsis;
  width: 7rem;
  color: $link-tab-color;
  text-align: center;
}

.search_calendar {
  // width: 6.8rem;
  flex: 2.5;
}

.search_numpeople {
  // width: 5rem;
  flex: 1.5;
}

.search_keyword {
  flex: 6;
}

.search {
  display: flex;
  height: 100%;
  flex-grow: 1;
  align-items: center;
  i {
    margin: auto 0.5rem;
  }
}

.s_input {
  border: 0;
  height: inherit;
  background-color: inherit;
  width: -webkit-fill-available;
}
</style>
